/* eslint-disable */
import React, { createRef, useState, useEffect } from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import ReactIdSwiper from 'react-id-swiper';
import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm';
import { Picture } from '~/components/Elements/Picture';
import { PosterArrowButton, PosterArrowButtonPrev } from '~/components/ArrowButton';
import { Img } from '~/components/Elements/Img';
import { DataLayer } from '~/components/DataLayer';
import { Quote } from '~/components/Quote';
import configData from '~/config/data';
import css from './PosterPage.scss';

const classes = {
	root: css.posterPage,
	content: css.posterPageContent,
	background: css.posterPageBackground,
	arrowPrev: css.posterPageArrowPrev,
	arrowNext: css.posterPageArrowNext,
	quote: css.posterPageQuote,
	card: css.posterPageCard,
	cardTail: css.posterPageCardTail,
	poster: css.posterPagePoster,
	posterVideo: css.posterPagePosterVideo,
	posterItem: css.posterPagePosterItem,
	posterPicture: css.posterPagePosterPicture,
	posterImage: css.posterPagePosterImage,
	posterLoader: css.posterPagePosterLoader,
	posterList: css.posterPagePosterList,
	posterC2A: css.posterPagePosterC2A,
	thumb: css.posterPageThumb,
	thumbItem: css.posterPageThumbItem,
	thumbImage: css.posterPageThumbImage,
	bullet: css.posterPageBullet,
	bulletList: css.posterPageBulletList,
	bulletItem: css.posterPageBulletItem,
	isActive: css.isActive,
	isSimple: css.isSimple,
	header: css.posterPageHeader,
	headerTitle: css.posterPageHeaderTitle,
	headerSubtitle: css.posterPageHeaderSubtitle,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	data: PropTypes.object,
};

const defaultProps = {
	className: '',
	classes,
	data: configData.poster,
};

export function PosterPage({ className, classes, data: info, ...props }) {
	console.log('POSTER PAGE PROPS :: ', props.mobile);
	const $el = createRef();
	const [data, setData] = useState(info.data);
	const [swiperPoster, updateSwiperPoster] = useState(null);
	const [currentIndex, setCurrentIndex] = useState(0);
	 const [numUserInteractions, setNumUserInteractions] = useState(0);

	const slideNextPoster = (speed, runCallbacks) => {
		swiperPoster && swiperPoster.slideNext();
		setCurrentIndex(1);
	};

	const slidePrevPoster = (speed, runCallbacks) => {
		swiperPoster && swiperPoster.slidePrev();
		setCurrentIndex(0);
	};

	const slideToPoster = (index, speed, runCallbacks, internal) => {
		setNumUserInteractions(numUserInteractions + 1);
		swiperPoster && swiperPoster.slideTo(index, speed, runCallbacks, internal);
	};

	const onPosterSlideChange = () => {
		DataLayer.push('GalleryPage_MudouPoster', swiperPoster.realIndex);
		console.log('swiperPoster.realIndex:', swiperPoster.realIndex);
	};

	const onPosterResize = () => {
		swiperPoster && swiperPoster.update();
	};

	useEffect(() => {
		if (swiperPoster) {
			swiperPoster.on('slideChange', onPosterSlideChange);
			swiperPoster.on('resize', onPosterResize);
		}
		return () => {
			if (swiperPoster) {
				swiperPoster.off('slideChange', onPosterSlideChange);
				swiperPoster.off('resize', onPosterResize);
			}
		};
	}, [swiperPoster]);

	const renderThumb = (item, index) => {
		return (
			<div key={index} className={cls(classes.thumbItem)}>
				<DataLayer onEvent={'GalleryPage_ClicouThumb'} args={[index]}>
					<Img
						className={cls(classes.thumbImage, { [classes.isActive]: index === currentIndex })}
						onClick={() => slideToPoster(index)}
						data-src={item.thumbnail}
						src={item.thumbnail}
						alt={item.alt}
					/>
				</DataLayer>
			</div>
		);
	};

	const renderThumbs = (list) => {
		return list.length > 1 && list.map(renderThumb);
	};

	const renderVideo = (item, index) => {
		return (
			<div key={index} className={cls(classes.posterVideo)}>
				<ReactPlayer url={item.video} playing={index === currentIndex} width='100%' height='100%' />
			</div>
		);
	};

	const renderArrows = (item) => {
		console.log('currentIndex:', currentIndex);
		return (
			<div className={cls(classes.arrow)}>
			   <DataLayer onEvent={'AboutPage_ClicouAvancar'} args={[item.title]}>
					<PosterArrowButtonPrev
						className={cls(classes.arrowPrev)}
						onClick={slidePrevPoster}
						disabled={currentIndex === 0}
					/>
			   </DataLayer>

			   { currentIndex === 0 && 
			   	<DataLayer>
			   		<div className="posterImage-arrowVertical-rigth"></div>
		   		</DataLayer>
			   }
			   
			   <DataLayer onEvent={'AboutPage_ClicouVoltar'}  args={[item.title]}>
				   <PosterArrowButton
					   className={cls(classes.arrowNext)}
					   onClick={slideNextPoster}
					   disabled={currentIndex >= data.list.length - 1}
				   />
			   </DataLayer>

			   { currentIndex >= data.list.length - 1 &&
			   	<DataLayer>
			   		<div className="posterImage-arrowVertical-left"></div>
		   		</DataLayer>
			   }

			</div>
		);
	};

	const renderPoster = (item, index) => {
		return (
			<div key={index} className={cls(classes.posterItem)}>
				<DataLayer onEvent={'GalleryPage_ClicouPoster'} args={[item.title]}>
					<Picture
						className={cls(classes.posterPicture)}
						classNameImg={cls(classes.posterImage, 'swiper-lazy')}
						sources={item.poster.sources}
						alt={item.poster.alt}
					/>
				</DataLayer>
				<div className={cls(classes.posterLoader, 'swiper-lazy-preloader', 'swiper-lazy-preloader-white')} />
			</div>
		);
	};

	const renderPosters = (list) => {
		const listElements = list.map((item, index) => {
			if (item.video) return renderVideo(item, index);
			return renderPoster(item, index);
		});
		swiperPoster && swiperPoster.update();
		return listElements;
	};

	const renderBullet = (item, index) => {
		return (
			<DataLayer key={index} onEvent={'GalleryPage_ClicouBullet'} args={[item.title]}>
				<button
					className={cls(classes.bulletItem, {
						[classes.isActive]: index === currentIndex,
					})}
					onClick={() => slideToPoster(index)}
				 />
			</DataLayer>
		);
	};

	const renderBullets = (list) => {
		return list.map(renderBullet);
	};

	return (
		<section
			ref={$el}
			id={PosterPage.displayName}
			data-ui-anchor={PosterPage.displayName}
			className={cls(classes.root, className)}>
			{/* Background ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}

			{/* Gallery ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/}
			<div className={cls(classes.card)}>
				 <div className={cls(classes.cardTail)} />
				{renderArrows(data.list[currentIndex])}
				<div className={cls(classes.poster)}>
					<ReactIdSwiper
						containerClass={cls(classes.posterList)}
						direction={'horizontal'}
						Swiper={Swiper}
						getSwiper={updateSwiperPoster}
						slidesPerView={1}
						spaceBetween={0}
						lazy={true}
						loop={false}
						noSwiping={true}
						centerInsufficientSlides={true}
						loopFillGroupWithBlank={true}
						grabCursor={true}
						centeredSlides={false}
						initialSlide={currentIndex}>
						{renderPosters(data.list)}
					</ReactIdSwiper>
				</div>
				<header className={cls(classes.header)}>
					<h2 className={cls(classes.headerSubtitle)}>FIAT STRADA</h2>
				</header>
			</div>
		 </section>
	);
}

PosterPage.displayName = 'PosterPage';
PosterPage.propTypes = propTypes;
PosterPage.defaultProps = defaultProps;
export default PosterPage;